var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnyFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7OC0bb_0rkmVY7Mwj6ZH6a",
    x1: 17,
    x2: 17,
    y1: 46.25,
    y2: 55.004,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7OC0bb_0rkmVY7Mwj6ZH6a)",
    d: "M13,46v6c0,1.105,0.895,2,2,2h6L13,46z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7OC0bb_0rkmVY7Mwj6ZH6b",
    x1: 32,
    x2: 32,
    y1: 5.333,
    y2: 58.343,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7OC0bb_0rkmVY7Mwj6ZH6b)",
    d: "M52,37V12c0-1.302-0.839-2.402-2-2.816V9c0-1.654-1.346-3-3-3H17c-1.654,0-3,1.346-3,3v0.184 c-1.161,0.414-2,1.514-2,2.816v12c-1.654,0-3,1.346-3,3v26c0,2.757,2.243,5,5,5h37v0c0.071,0,0.142-0.002,0.214-0.005 C53.337,57.884,55,56.054,55,53.83V40C55,38.346,53.654,37,52,37z M44,11h5c0.552,0,1,0.448,1,1v6h-5c-0.552,0-1-0.448-1-1V11z M17,8h30c0.552,0,1,0.448,1,1H16C16,8.448,16.448,8,17,8z M11,53V27c0-0.552,0.448-1,1-1h7.93c0.335,0,0.646,0.166,0.832,0.445 l2.812,4.216C24.131,31.5,25.065,32,26.073,32H46c0.552,0,1,0.448,1,1v21c0,0.709,0.209,1.394,0.56,2H14C12.346,56,11,54.654,11,53z M53,53.83c0,1.141-0.849,2.112-1.891,2.167c-0.552,0.025-1.084-0.165-1.486-0.547C49.222,55.068,49,54.554,49,54V33 c0-1.654-1.346-3-3-3H26.073c-0.337,0-0.649-0.167-0.836-0.447l-2.812-4.217C21.868,24.499,20.935,24,19.93,24H14V12 c0-0.552,0.448-1,1-1h27v6c0,1.654,1.346,3,3,3h5v34c0,0.553,0.447,1,1,1s1-0.447,1-1V39c0.552,0,1,0.448,1,1V53.83z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7OC0bb_0rkmVY7Mwj6ZH6c",
    x1: 28,
    x2: 28,
    y1: 5.333,
    y2: 58.343,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7OC0bb_0rkmVY7Mwj6ZH6c)",
    d: "M18 14H38V16H18z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7OC0bb_0rkmVY7Mwj6ZH6d",
    x1: 28,
    x2: 28,
    y1: 5.333,
    y2: 58.343,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7OC0bb_0rkmVY7Mwj6ZH6d)",
    d: "M18 18H38V20H18z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7OC0bb_0rkmVY7Mwj6ZH6e",
    x1: 32,
    x2: 32,
    y1: 5.333,
    y2: 58.343,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7OC0bb_0rkmVY7Mwj6ZH6e)",
    d: "M26 22H38V24H26z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7OC0bb_0rkmVY7Mwj6ZH6f",
    x1: 32,
    x2: 32,
    y1: 5.333,
    y2: 58.343,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7OC0bb_0rkmVY7Mwj6ZH6f)",
    d: "M26 26H38V28H26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnyFileIcon);
export default __webpack_public_path__ + "static/media/any-file-icon.c7bdf0a0a1acae3c3f3a228652331ab0.svg";
export { ForwardRef as ReactComponent };